export const IMAGE_VARIANTS = {
  SCALED_SMALL: 'scaled-small',
  SCALED_MEDIUM: 'scaled-medium',
  SCALED_LARGE: 'scaled-large',
  SCALED_XLARGE: 'scaled-xlarge',
};
